import styled, { css } from 'styled-components';
import { Box, Text } from '@bechtel/gds';

export const CalulationParametersStyled = styled(Text).attrs({
  weight: '600',
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[200]};
    text-align: center;
    margin: 0 ${theme.spacings[400]};
    padding-top: ${theme.spacings[100]};
    padding-bottom: ${theme.spacings[100]};
    padding-left: ${theme.spacings[200]};
    padding-right: ${theme.spacings[200]};
  `}
`;

export const TargetCalculationStyled = styled(Box).attrs({ px: { sm: '400' }, py: { sm: '400' } })`
  ${({ theme }) => css`
    border-top: 1px solid ${theme.colors.grey[200]};
    font-size: ${theme.fontSizes[300]};
  `}
`;
